import {Grid, Switch, Typography} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import {useController, useFormContext} from 'react-hook-form'

import {EventGoal, useFormUserEventHandler} from '../../lib/metrika'
import * as classes from './BusinessToggle@desktop.classes'

export function BusinessToggle() {
  const {control} = useFormContext()
  const i18n = useI18n()
  const {field, fieldState} = useController({control, name: 'is_business', defaultValue: false})
  const handleReachGoal = useFormUserEventHandler()

  function handleChange(value: boolean) {
    field.onChange(value)
    handleReachGoal(EventGoal.BusinessSwitchClick)
  }

  return (
    <Grid alignItems="center" container>
      <Grid item>
        <Typography className={classes.caption} group="normal" thickness="bold" variant="caption1">
          {i18n('form.ntl.field.is-business', 'Бизнес')}
        </Typography>
      </Grid>
      <Grid className={classes.toggle} item>
        <Switch
          data-e2e="business-switch"
          error={fieldState.invalid}
          on={field.value}
          onChange={handleChange}
          size="m"
        />
      </Grid>
    </Grid>
  )
}
